import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="enable-discover-matches"
export default class extends Controller {
  static targets = ["radioOption", "textField", "button"]
  static values = { enabled: { type: Boolean, default: false } }

  connect() {
    this.toggle()
  }

  toggle() {
    let radioOptionChecked = this.radioOptionTargets.some((element) => {
      return element.checked
    })
    let textFieldFilled = this.textFieldTargets.some((element) => {
      return element.value !== ""
    })

    this.enabledValue = radioOptionChecked || textFieldFilled
  }

  preventSubmit(event) {
    if (event.type === "keydown") {
      event.preventDefault()
    }
  }

  enabledValueChanged() {
    this.buttonTarget.disabled = !this.enabledValue
  }
}
